<template>
  <div class="Model">
    <Modal
      v-model="modelStatus"
      title="日志清理"
      :closable="false"
      :mask-closable="false"
      :footer-hide="true"
    >
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="90">
        <FormItem label="执行器:" prop="jobGroup">
          <Select v-model="formValidate.jobGroup" placeholder="请选择执行器" @on-change="handleTask">
            <Option v-for="item in selectList" :value="item.id" :key="item.id">{{ item.title }}</Option>
          </Select>
        </FormItem>
        <FormItem label="任务:" prop="jobId">
          <Select v-model="formValidate.jobId" placeholder="请选择任务">
            <Option v-for="item in jabData" :value="item.id" :key="item.id">{{ item.jobDesc }}</Option>
          </Select>
        </FormItem>
        <FormItem label="清理方式:" prop="type">
          <Select v-model="formValidate.type" placeholder="请选择清理方式">
            <Option v-for="item in toDay" :value="item.value" :key="item.value">{{ item.label }}</Option>
          </Select>
        </FormItem>
    </Form>
    <!-- 按钮组 -->
    <div class="btn-box">
      <Button  class="ys-cancel" @click="cancel('formValidate')" style="width: 100px; margin-right: 20px">取消</Button>
      <Button class="ys-confirm" type="primary" @click="ok('formValidate')" style="width: 100px;">确认</Button>
    </div>
    </Modal>
  </div>
</template>
<script>
import { 
  mapActions
} from "vuex";
export default {
  props:{
    modelStatus: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      formValidate: {
        jobGroup: '',
        jobId: '',
        type: ''
      },
      ruleValidate: {
        jobGroup: [
          { required: true, message: '请选择执行器', trigger: 'change', type: 'number' }
        ],
        jobId: [
          { required: true, message: '请选择任务', trigger: 'change', type: 'number' }
        ],
        type: [
          { required: true, message: '请选择清理方式', trigger: 'change', type: 'number' }
        ],
      },
      toDay: [
        { value: 1, label: '清理一个月之前日志数据' },
        { value: 2, label: '清理三个月之前日志数据' },
        { value: 3, label: '清理六个月之前日志数据' },
        { value: 4, label: '清理一年之前日志数据' },
        { value: 5, label: '清理一千条以前日志数据' },
        { value: 6, label: '清理一万条以前日志数据' },
        { value: 7, label: '清理三万条以前日志数据' },
        { value: 8, label: '清理十万条以前日志数据' },
        { value: 9, label: '清理所有日志数据' },
      ],
      selectList: null,
      jabData: null,
    }
  },
  methods:{
    ...mapActions([
      'sa_SpringJobInfoView_index', // 下拉列表
      'sa_SpringJonLogView_getJobsByGroup', // 根据执行器去查询任务
      'sa_SpringJonLogView_clearLog', // 清理日志
    ]),
    ok (name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
          this.sa_SpringJonLogView_clearLogs();
        } else {
          this.$Message.error('Fail!');
        }
      })
    },
    cancel (name) {
      this.$refs[name].resetFields();
      this.$emit('handle-model', {code: 2})
    },
    // 修改执行器
    handleTask() {
      this.sa_SpringJonLogView_getJobsByGroups();
    },
    // 获取下拉列表
    async sa_SpringJobInfoView_indexs() {
      try {
        const data = await this.sa_SpringJobInfoView_index();
        this.selectList = data.JobGroupList;
      } catch (error) {
        console.log(error);
      }
    },
    // 查询任务
    async sa_SpringJonLogView_getJobsByGroups() {
      try {
        const data = await this.sa_SpringJonLogView_getJobsByGroup({jobGroup: this.formValidate.jobGroup});
        this.jabData = data;
      } catch (error) {
        console.log(error);
      }
    },
    // 清理日志
    async sa_SpringJonLogView_clearLogs() {
      try {
        const data = await this.sa_SpringJonLogView_clearLog(this.formValidate);
        this.$Message.success('清理成功!');
        this.$emit('handle-model', {code: 1})
      } catch (error) {
        console.log(error);
      }
    }
  },
  mounted() {
    // 获取下拉列表
    this.sa_SpringJobInfoView_indexs();
  }
}
</script>
<style lang="less" scoped>
.btn-box {
  width: 100%;
  display: flex;
  flex-wrap: nowrap;
  justify-content: flex-end;
  margin-top: 40px;
}
</style>